import classNames from "classnames";
import { MouseEvent } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Typography } from "@mui/material";

import { appVersion } from "utils/env";
import LocalStorage from "services/LocalStorage";
import styles from "./changeLog.module.scss";

export interface ChangeLogProps {
  changes?: string[];
  open: boolean;
  onClose: () => void;
}

function ChangeLog(props: ChangeLogProps) {
  const { open, changes, onClose } = props;
  const localStorage = LocalStorage.getInstance();

  /**
   * Handle close dialog
   *
   * @param event
   * @param reason
   * @returns undefined
   */
  function handleCloseDialog(_: MouseEvent, reason?: "backdropClick" | "escapeKeyDown") {
    if (reason === "backdropClick") return;

    localStorage.setChangelogVersion(appVersion ?? "0");

    onClose();
  }

  return (
    <Dialog onClose={handleCloseDialog} open={open} maxWidth='xs'>
      <Box p={2}>
        <Typography variant='h6' className={styles.dialogTitle}>
          What&#39;s New - v{process.env.VITE_VERSION}
        </Typography>
        <Typography variant='caption' color='textSecondary'>
          February 5, 2024
        </Typography>
      </Box>

      <DialogContent dividers>
        {/* NEW FEATURES */}
        <Box mb={2} className={styles.section}>
          <Typography className={styles.featuresTitle}>
            <b>✨ NEW FEATURES</b>
          </Typography>

          <Divider className={classNames(styles.divider, styles.featuresDivider)} />
        </Box>
        {changes?.length ? (
          <ul>
            {changes.map((change, index) => (
              <li key={index}>
                <Box mb={1}>
                  <Typography variant='body2'>{change}</Typography>
                </Box>
              </li>
            ))}
          </ul>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color='primary' variant='outlined'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangeLog;
